import { useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import Alinia from "../../elements/Alinia";
import Button from "../../elements/Button";
import { resolveLink } from "../../helpers/resolveLink";
import type {
  DownloadSectieStoryblok,
  DownloadgGroupStoryblok,
  ButtonStoryblok,
} from "../../../component-types-sb";
import "./downloadSectie.scss";

const DownloadCard = ({ card }: { card: DownloadgGroupStoryblok }) => {
  const [open, setOpen] = useState(false);
  const downloadCount = card.downloads?.length ?? 0;

  return (
    <div
      className={`download-card ${
        card.backgroundColor === "purple" ? "purple" : "pink"
      }`}
    >
      <div className="card-header" onClick={() => setOpen((prev) => !prev)}>
        {card.title && <p className="card-title">{card.title}</p>}
        <div className="card-header-meta">
          <span className="download-count">{downloadCount}</span>
          <span className={`dropdown-triangle${open ? " open" : ""}`} />
        </div>
      </div>
      {card.description && (
        <Alinia className="card-description" text={card.description} />
      )}
      {open && (
        <div className="download-links">
          {card.downloads &&
            card.downloads.map((download: ButtonStoryblok) => {
              const { href, target } = resolveLink(download.Link);
              return (
                <Button
                  key={download._uid}
                  link={href}
                  target={target}
                  label={download.text}
                  icon="download"
                />
              );
            })}
        </div>
      )}
    </div>
  );
};

const DownloadSectie = ({ blok }: { blok: DownloadSectieStoryblok }) => {
  return (
    <section className="section-download-sectie" {...storyblokEditable(blok)}>
      {blok.cards &&
        blok.cards.map((card: DownloadgGroupStoryblok) => (
          <DownloadCard card={card} key={card._uid} />
        ))}
    </section>
  );
};

export default DownloadSectie;
